import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Flex, Form, Input, Row, Popconfirm } from "antd";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { getLogEntries, deleteReport, clearData } from "./reportSlice";
import { HeaderCell } from "../Dashboard/HeaderCell";
import { dateCell } from "../../components/DateCell/DateCell";
import { Notification } from "../../components/Notification/Notification";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import Table from "../../components/SortableTable/SortableTable";
import css from "../Dashboard/Dashboard.module.css";


export const Logs = ({upc}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [sortDirection, setSortDirection] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  
  const [type, setType] = useState("type");
  const page = new URLSearchParams(location.search).get("page") || 1;
  const search = new URLSearchParams(location.search).get("search");
  const sort = new URLSearchParams(location.search).get("sort");

  const { logEntries, getLogEntriesProgress } =
	useSelector((state) => state?.report) || {};

  useEffect(() => {
	dispatch(
	  getLogEntries({
		type,  
		page,
		search,
		sort: sortDirection,
	  }),
	);
  }, [type, page, search, sortDirection]);
  
  useEffect(() => {
	  if (
		location.state &&
		["/uploaded"].includes(location.state.from)
	  ) {
		setShowNotification(true);
		navigate("/report/logs", { state: null });
	  } else {
		setShowNotification(false);
	  }
  }, [location?.state]);
  
  const deleteReportCall = async (id) => {
	  await dispatch(deleteReport(id));
	  await dispatch(getLogEntries());
  }
  
  const columns = [
	{
	  title: "Import Date",
	  editable: true,
	  dataIndex: "importedAt",
	  sorter: true,
	  align: "left",
	  render: (record) => dateCell(record)
	},
	{
	  title: "Filename",
	  editable: true,
	  dataIndex: "filename",
	  sorter: (_, __, sort) =>
		setSortDirection(`filename:${sort === "ascend" ? "asc" : "desc"}`),
	  align: "left"
	},
	{
	  title: "User",
	  editable: true,
	  dataIndex: "user",
	  sorter: true,
	  align: "left"
	},
	{
	  title: "# Lines Ingested",
	  editable: true,
	  dataIndex: "lines",
	  width: 170,
	  sorter: true,
	  align: "left",
	},
	{
	  title: "Actions",
	  dataIndex: "",
	  fixed: "right",
	  key: "x",
	  width: 100,
	  align: "left",
	  render: (record) => {
		return (
		  <Flex gap={16} align={"center"}>
			<div className={css.actionContainer}>
				<Popconfirm
				title="Are you sure you want to delete this report?"
				onConfirm={() => {
					deleteReportCall(record.rowKey.id);
				}}
				okText="Yes"
				cancelText="No"
				>
	
					Undo (delete)
				</Popconfirm>
			</div>
		  </Flex>
		);
	  },
	},

	
  ];

  return (
	  <>
	  <PageHeader title="Import Logs" extraClass={css.reportTitle} />
		<Flex className={css.root} vertical>
		<div className={"ibox-holder"}>

			<Notification
				message="Success"
				description={"File was uploaded successfully"}
				showNotification={showNotification}
				cancel={() => setShowNotification(false)}
			/>

			<Table
				components={{
					header: {
						row: HeaderCell,
					},
				}}
				columns={columns}
				rowKey={(record) => record.rowKey.id}
				dataSource={logEntries}
				pagination={{
					position: ["bottomRight"],
					responsive: true,
					// onChange: (page) => onQueryParamsChange({ page }),
					current: page,
					total: logEntries.length,
					pageSize: 10,
					hideOnSinglePage: true,
					showSizeChanger: false,
				}}
				loading={getLogEntriesProgress}
				style={{ marginTop: 10 }}
				scroll={{ x: "100%" }}
			/>
			</div>
		</Flex>
		
		</>
  );
};
